import { defineMessages } from 'react-intl';

export const ratingIconsWithInfoButtonMessages = defineMessages({
  ariaLabel: {
    id: 'customerRatings.ratingIconsWithInfo.aria.label',
    defaultMessage: 'zu den Produktbewertungen springen',
  },
});
